<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2LYoNg/tc-custom/9780738757377.jpg?1741984045839" alt="This image is the cover for the book Souls on Earth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Souls on Earth
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this “groundbreaking” book, a past-life regression therapist “offers credible evidence of evolved interplanetary souls incarnate in human bodies” (Larry Dossey, MD, author of </b><i><b>One Mind</b></i><b>).</b></p><p>In her work as a regression hypnotherapist, Dr. Linda Backman frequently meets with individuals who have had past lives on planets and realms beyond Earth. These individuals—called interplanetary souls—have agreed to come to Earth to help support the evolution of the planet as well as to develop themselves and learn lessons for spiritual advancement.</p><p>In <i>Souls on Earth</i>, Dr. Backman shares her fascinating work with interplanetary souls. This book explores the characteristics of interplanetary souls so that if you are one, you will be able to understand more about your life purpose and cope with the special challenges that come with an incarnation on Earth. Learn how to identify IP souls and discover how they can assist humanity's evolution. Explore ways to support yourself or loved ones who may be IP souls. For many people struggling with difficult lessons or trying to find meaning, this book opens the door to new understandings and the potential for peace.</p><p>“Dr. Backman describes . . . [how] some of us . . . are Interplanetary souls who have lived on other worlds and who are always conscious of being different yet are here for a reason." —Hank Wesselman, PhD, author of The Spiritwalker Trilogy </p><p>"Wonderfully written and thought-provoking." —Sandra Ingerman, MA, author of <i>Soul Retrieval</i></p><p>"I highly applaud Linda Backman for her dedication and courage in taking us on a fantastic voyage through time and space in her groundbreaking book." —Kim Russo, psychic medium, intuitive counselor, and host of <i>Psychic Intervention</i> and <i>The Haunting Of . . .</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Backman
      </h2>
      
      <p class="authorDescription body article"><P>Dr. Linda Backman (Colorado) is a licensed psychologist with more than forty-five years of experience in private practice. Dr. Backman studied, co-taught, and co-established The Society for Spiritual Regression (now the Newton Institute) with pioneering therapist and best-selling author Dr. Michael Newton. She has conducted thousands of past-life and between-lives hypnotherapy regression sessions.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ed19669